"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationConfirmationResult = void 0;
var ReservationConfirmationResult;
(function (ReservationConfirmationResult) {
    ReservationConfirmationResult["successful"] = "successful";
    ReservationConfirmationResult["failed"] = "failed";
    ReservationConfirmationResult["tokenInvalid"] = "tokenInvalid";
    ReservationConfirmationResult["tokenExpired"] = "tokenExpired";
    ReservationConfirmationResult["reservationNotPending"] = "reservationNotPending";
})(ReservationConfirmationResult || (exports.ReservationConfirmationResult = ReservationConfirmationResult = {}));
//# sourceMappingURL=ReservationConfirmationResult.js.map